import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Link,
  Image,
  Font,
} from "@react-pdf/renderer";
import Table from "../../components/pdf/table";
import FirstPage from "./FirstPage";

const EventSummaryReport = ({ buildingName, start, end, contentData }) => {
  Font.register({
    family: "NotoSansTC",
    src: "/fonts/NotoSansTC-Regular.ttf",
  });
  const styles = StyleSheet.create({
    // general
    page: {
      flexDirection: "column",
      backgroundColor: "#FFFFFF",
      padding: 40,
      lineHeight: 1.5,
      fontSize: 14,
    },
    sectionTitle: {
      fontSize: 18,
      fontFamily: "Helvetica-Bold",
      marginTop: 5,
      marginBottom: 5,
    },
    visualHeader: {
      fontSize: 14,
      fontFamily: "Helvetica-Bold",
      textAlign: "center",
    },
    visualDescription: {
      marginTop: 5,
      fontSize: 11,
      textAlign: "right",
      color: "gray",
    },
  });

  const headerData = [
    {
      columnName: "Rank",
      columnKey: "Rank",
      columnStyle: {},
      handleClick: null,
    },
    {
      columnName: "Room",
      columnKey: "Room",
      columnStyle: {},
      handleClick: null,
    },
    {
      columnName: "Ammonia",
      columnKey: "Ammonia",
      columnStyle: {},
      handleClick: null,
    },
    {
      columnName: "Paper Roll",
      columnKey: "Paper Roll",
      columnStyle: {},
      handleClick: null,
    },
    {
      columnName: "Hand Towel",
      columnKey: "Hand Towel",
      columnStyle: {},
      handleClick: null,
    },
    {
      columnName: "Soap",
      columnKey: "Soap",
      columnStyle: {},
      handleClick: null,
    },
    {
      columnName: "Total",
      columnKey: "Total",
      columnStyle: {},
      handleClick: null,
    },
  ];
  return (
    <Document title="CBM Smart Toilet System Report" pageLayout="oneColumn">
      <FirstPage
        reportName={"Event Summary"}
        buildingName={buildingName}
        start={start}
        end={end}
      />
      <Page size="A4" style={styles.page}>
        <View>
          <Text style={styles.sectionTitle} id="event">
            Event Summary
          </Text>

          <Text style={styles.visualHeader}>Sensor events ranked by rooms</Text>

          <Table>
            <Table.Thead
              headerData={headerData}
              fontSize={"10px"}
              widthArray={[3, 10, 5, 5, 5, 4, 4]}
            />
            <Table.Tbody
              headerData={headerData}
              fontSize={"10px"}
              widthArray={[3, 10, 5, 5, 5, 4, 4]}
              contentData={contentData}
              breakArray={[28, 31]}
            />
          </Table>

          {Array.isArray(contentData) && contentData.length === 0 && (
            <Text
              style={[{ fontSize: 20, marginTop: "10px", textAlign: "center" }]}
            >
              -- No Data --
            </Text>
          )}

          <Text style={[styles.visualDescription]}>
            * A sensor event is recorded everytime an alerted sensor goes
            offline or returns normal.
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default EventSummaryReport;
